// TODO monthly plan can be removed when using standard plan
import theme from '../../theme'

export const planType = {
  ANNUAL: 'ANNUAL',
  STANDARD: 'STANDARD',
  BASIC: 'BASIC',
  TVOD: 'TVOD',
  SIX_MONTH_OFFER: 'BUNDLE_2021_SIX_MONTH'
}

/**
 * content for display in subscription modal
 */
export const modalContent = {
  selection: 'selection',
  voucher: 'voucher',
  payment: 'payment',
  paymentMethods: 'paymentMethod',
  confirmation: 'confirmation',
  voucherValidateErrorAfterLogin: 'voucherValidateErrorAfterLogin',
  accountDetails: 'accountDetails',
  error: 'error'
}

export const paymentCopy = {
  standard:
    `Flexible cancelling at any time. <a target="_blank" href="/pages/terms" style="color:${theme.neonPrimary};text-decoration:underline;text-underline-offset:2px">Terms apply</a>`,
  basic:
    `Flexible cancelling at any time. <a target="_blank" href="/pages/terms" style="color:${theme.neonPrimary};text-decoration:underline;text-underline-offset:2px">Terms apply</a>`,
  tvod: 'No upfront charges. No monthly subscription. Pay as you go!',
  annual:
    `Flexible cancelling at any time. <a target="_blank" href="/pages/terms" style="color:${theme.neonPrimary};text-decoration:underline;text-underline-offset:2px">Terms apply</a>`
}

export const serverErrors = {
  VOUCHER_EXPIRED: 'Sorry, the voucher you have used has expired',
  VOUCHER_INVALID: 'Sorry, the voucher you have used is not valid',
  VOUCHER_REDEEMED: 'Sorry, this voucher has already been redeemed',
  DEFAULT:
    'We had an issue while trying to process your request, please try again or contact one of our support representatives if the problem persists'
}

export const creditCardStatus = {
  ACTIVE: 'ACTIVE'
}
export const signupImage =
  'https://lightbox-prod.imgix.net/images/static/Neon_Devices_Lockup.png?q=75'

export const priceChangeAlertMessage = {
  myAccount: `Neon's price is changing. A monthly Basic Plan will increase to $14.99 per month if your next billing date is on or after 15 October 2025.`,
  standard: ``,
  annual: ``,
  basic: `<b>Neon's price is changing</b>. Your new Basic Plan will increase to $14.99 per month if your plan renews on or after 15 October 2025.`,
  modalHeader: `Neon's price is changing`,
  modalMessage: `On 15 October 2025 Neon's Basic Plan will increase to $14.99 per month.`
}

export const paymentAlertMessage = 'Please don’t refresh the page after submitting payment.'
